export type EMoneyInboundContactSyncSettings = {
  autoSync: boolean
}

export type EMoneyInboundSyncSettings = {
  contact: EMoneyInboundContactSyncSettings
}

export type EMoneySettingsFormValues = {
  inbound: EMoneyInboundSyncSettings
}

export const eMoneySettingsDefaultValues: EMoneySettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
}
